import {
  CtaBuilderFn,
  InstantAnswerBuilderFn,
} from "@faire/help-center-self-serve/types";
import { getSettingRetailerExclusivityAgreements } from "@faire/help-center-utils/settings/getSettingRetailerExclusivityAgreements";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { ViewInvoicesCTA } from "./ctas";

export const BulkDownloadIA: InstantAnswerBuilderFn = (strictLocalize) => {
  return {
    titleBuilder: (_context) => {
      return BULK_DOWNLOAD_INVOICES(strictLocalize);
    },

    descriptionBuilder: (_context) => {
      return [HOW_TO_BULK_DOWNLOAD_INVOICES(strictLocalize)];
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getPrimaryCTA(context, strictLocalize)?.label;
      },
      linkBuilder: (context) => {
        return getPrimaryCTA(context, strictLocalize)?.getLink?.();
      },
    },
  };
};

const getPrimaryCTA: CtaBuilderFn = (_context, strictLocalize) => {
  return ViewInvoicesCTA(strictLocalize);
};

const BULK_DOWNLOAD_INVOICES = (strictLocalize: StrictLocalizeFunction) => {
  if (getSettingRetailerExclusivityAgreements()) {
    return strictLocalize({
      defaultMessage: "Download invoices",
      description: {
        text: "Title for the answer of the question “How do I download invoices?“",
      },
    });
  }
  return strictLocalize({
    defaultMessage: "Bulk download invoices",
    description: {
      text: "Title for the answer of the question “How do I bulk download invoices?“",
    },
  });
};

const HOW_TO_BULK_DOWNLOAD_INVOICES = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "You can download your invoices in bulk by selecting the checkboxes next to the invoices and then clicking on the Download invoices button at the top of the Invoices page.",
    description: {
      text: "Description for the answer of the question “How do I bulk download invoices?“",
    },
  });
